<div *ngIf="hardwareRequest">
  <div class="stick-top">
    <mat-toolbar
      ><mat-icon>build</mat-icon>
      {{
        hardwareRequest.id ? "Hardware Request - " + hardwareRequest.requestNumber : "Create new Hardware Request"
      }}</mat-toolbar
    >
    <div class="hbox lightly-padded button-bar">
      <button
        mat-raised-button
        class="primary"
        type="button"
        (click)="save()"
        [disabled]="validatingCompany || companyValidationFailed || !hasRequiredSelections || !form.form.valid"
      >
        <mat-icon>{{ hardwareRequest.id ? "save" : "add" }}</mat-icon>
        {{ hardwareRequest.id ? "Update" : "Add" }}
      </button>
      <micro-delete-confirm
        *ngIf="hardwareRequest.id"
        (onConfirm)="delete()"
      ></micro-delete-confirm>
    </div>
  </div>
  <div class="padded">
    <p *ngIf="companyValidationFailed">
      Unable to validate the selected records for this company.
      <button mat-button type="button" (click)="validateCompanySelections()">Retry</button>
    </p>
    <form #form="ngForm" role="form">
      <table class="basicTable vtable">
        <thead>
          <tr>
            <th colspan="100">Hardware Request Details</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="auth.isCompanyAdmin()"><th>Company</th><td><micro-company-select [companyId]="hardwareRequest.companyId" (companyIdChange)="onCompanyChange($event)" [required]="true"></micro-company-select></td></tr>
          <tr>
            <th>
              <micro-valid-label
                for="requestNumber"
                [model]="requestNumber"
                label="Request Number"
              ></micro-valid-label>
            </th>
            <td style="padding: 5px;">
              {{hardwareRequest.name}}
            </td>
          </tr>
          <tr>
            <th>Requested By</th>
            <td style="padding: 5px;">
              <micro-user-lookup [userId]="hardwareRequest.requestedBy"></micro-user-lookup>
            </td>
          </tr>
          <tr>
            <th>Application</th>
            <td>
              <micro-select-pagination
                apiUrl="/domain/cmdbApplications"
                [params]="{companyId: hardwareRequest.companyId}"
                [disabled]="validatingCompany || !hardwareRequest.companyId"
                routerBase="/cmdbApplications"
                [(id)]="hardwareRequest.applicationId"
                [defaultOption]="selectedValues.application"
                placeholder="Select Application"
                (objectChange)="onApplicationSelectedChange($event)"
              ></micro-select-pagination>
            </td>
          </tr> 
           <tr>
            <th>Tag</th>
            <td>
              <div class="hbox">
              {{ hardwareRequest.applicationTagName ? hardwareRequest.applicationTagName : 'No Tag Selected' }}
                <!-- <input style="flex: 1;" #applicationTag="ngModel" [(ngModel)]="hardwareRequest.applicationTagName" placeholder="Application Tag" id="applicationTagName" name="applicationTagName" disabled /> -->
                <div class="margin-auto" *ngIf="!validatingCompany && hardwareRequest.applicationTagId && hardwareRequest.applicationTagName && hardwareRequest.applicationTagName !== 'undefined' && hardwareRequest.applicationTagName !== 'Unknown tag'">
                  <a class="margin-auto" routerLink="/applicationTags/{{ hardwareRequest.applicationTagId }}" matTooltip="Jump to {{ hardwareRequest.applicationTagName }}" ><mat-icon class="icon-small">call_made</mat-icon></a>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th>Class Code</th>
            <td>
              <micro-select-pagination
                apiUrl="/domain/cmdbClassCodes"
                [params]="{companyId: hardwareRequest.companyId}"
                [disabled]="validatingCompany || !hardwareRequest.companyId"
                routerBase="/classCodes"
                [(id)]="hardwareRequest.classCodeId"
                [defaultOption]="selectedValues.classCodeId"
                placeholder="Select Class Code"
                (objectChange)="onSelectedChange('classCodeId', $event)"
              ></micro-select-pagination>
            </td>
          </tr>
          <!-- <tr><th>Environment</th><td><micro-environment-select [(environmentId)]="hardwareRequest.environmentId" [required]="true"></micro-environment-select></td></tr> -->
          <!-- <tr>
            <th>Server Size</th>
            <td>
                <micro-select-combo
                    [placeholder]="'Select server size'"
                    [mode]="'simple'"
                    [(id)]="hardwareRequest.serverSize"
                    (idChange)="onSelectedChange('serverSize', $event)"
                    [options]="[
                      {
                        id: 'Small',
                        name: 'Small',
                        value: 'Small',
                      },
                      {
                        id: 'Medium',
                        name: 'Medium',
                        value: 'Medium',
                      },
                      {
                        id: 'Large',
                        name: 'Large',
                        value: 'Large',
                      }
                    ]"
                    [loading]="false"
                    [required]="true"
                    [jump]="true"
                    [pickList]="false"
                    [disabled]="false"
              ></micro-select-combo>
            </td>
          </tr> -->
          <tr>
            <th>Server Type</th>
            <td>
              <micro-select-pagination
                apiUrl="/domain/cmdbServerTypes"
                [params]="{companyId: hardwareRequest.companyId}"
                [disabled]="validatingCompany || !hardwareRequest.companyId"
                routerBase="/serverTypes"
                [(id)]="hardwareRequest.serverTypeId"
                [defaultOption]="selectedValues.serverTypeId"
                placeholder="Select Server Type"
                (objectChange)="onSelectedChange('serverTypeId', $event)"
              ></micro-select-pagination>
            </td>
          </tr>
          <tr>
            <th>OS Type</th>
            <td>
              <micro-select-pagination
                apiUrl="/domain/cmdbOsType"
                [params]="{companyId: hardwareRequest.companyId}"
                [disabled]="validatingCompany || !hardwareRequest.companyId"
                [(id)]="hardwareRequest.osTypeId"
                [defaultOption]="selectedValues.osTypeId"
                placeholder="Select OS Type"
                (objectChange)="onSelectedChange('osTypeId', $event)"
              ></micro-select-pagination>
            </td>
          </tr>
          <!-- <tr>
            <th>OS</th>
            <td>
              <micro-select-pagination
                apiUrl="/domain/cmdbOsFamily"
                routerBase="/os"
                [(id)]="hardwareRequest.osId"
                [defaultOption]="selectedValues.osId"
                placeholder="Select OS"
                (objectChange)="onSelectedChange('osId', $event)"
              ></micro-select-pagination>
            </td>
          </tr>
          <tr>
            <th>OS Version</th>
            <td>
              <micro-select-pagination
                apiUrl="/domain/cmdbOsVersions"
                routerBase="/osVersions"
                [(id)]="hardwareRequest.osVersionId"
                [defaultOption]="selectedValues.osVersionId"
                placeholder="Select OS Version"
                (objectChange)="onSelectedChange('osVersionId', $event)"
              ></micro-select-pagination>
            </td>
          </tr>
          <tr><th>Site</th><td><micro-site-select [(siteId)]="hardwareRequest.siteId" [required]="true"></micro-site-select></td></tr>
          <tr>
            <th>
              <micro-valid-label
                for="cpu"
                [model]="cpu"
                label="CPU"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #cpu="ngModel"
                [(ngModel)]="hardwareRequest.cpu"
                required
                id="cpu"
                name="cpu"
                type="number"
                min="0"
              />
            </td>
          </tr>
          <tr>
            <th>
              <micro-valid-label
                for="ram"
                [model]="ram"
                label="RAM"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #ram="ngModel"
                [(ngModel)]="hardwareRequest.ram"
                required
                id="ram"
                name="ram"
                type="number"
                min="0"
              />
            </td>
          </tr> -->
          <tr>
            <th>
              <micro-valid-label
                for="projectName"
                [model]="projectName"
                label="Project Name"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #projectName="ngModel"
                [(ngModel)]="hardwareRequest.projectName"
                required
                maxlength="50"
                id="projectName"
                name="projectName"
              />
            </td>
          </tr>
          <tr>
            <th>Project Manager</th>
            <td>
              <micro-select-pagination
                apiUrl="/auth/contacts"
                routerBase="contacts"
                [params]="{companyId: hardwareRequest.companyId}"
                [disabled]="validatingCompany || !hardwareRequest.companyId"
                [(id)]="hardwareRequest.projectManagerContactId"
                [defaultOption]="selectedValues.projectManagerContactId"
                placeholder="Select Project Manager"
                [required]="true"
                (objectChange)="onSelectedChange('projectManagerContactId', $event)"
              ></micro-select-pagination>
            </td>
          </tr>
          <!-- <tr>
            <th>Hosting Platform</th>
            <td>
              <micro-select-pagination
                apiUrl="/domain/cmdbHostingPlatform"
                routerBase="/hostingPlatforms"
                [(id)]="hardwareRequest.hostingPlatformId"
                [defaultOption]="selectedValues.hostingPlatformId"
                placeholder="Select Hosting Platform"
                (objectChange)="onSelectedChange('hostingPlatformId', $event)"
              ></micro-select-pagination>
            </td>
          </tr>
          <tr>
            <th>
              <micro-valid-label
                for="clusterId"
                [model]="clusterId"
                label="Cluster"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #clusterId="ngModel"
                [(ngModel)]="hardwareRequest.clusterId"
                required
                maxlength="50"
                id="clusterId"
                name="clusterId"
              />
            </td>
          </tr>
          <tr>
            <th>
              <micro-valid-label
                for="serverName"
                label="Server Name"
              ></micro-valid-label>
            </th>
            <td>
              <div style="padding: 2px; font-size: 13px;">
                {{hardwareRequest.serverName}}
              </div>
            </td>
          </tr> -->
        </tbody>
      </table>
    </form>
  </div>

  <micro-cmdb-server-requests *ngIf="hardwareRequest.id" [hardwareRequestId]="hardwareRequest.id"></micro-cmdb-server-requests>
</div>
